import React from "react"
import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"
import PropTypes from "prop-types"

//i18n
import { withTranslation } from "react-i18next"

const ConfirmModal = ({ modal, onToggle, onDelete, message, title, t, onSubmit }) => {
  return (
    <Modal centered={true} scrollable={true} isOpen={modal}>
      <ModalHeader toggle={onToggle} tag="h5">
        {title}
      </ModalHeader>
      <ModalBody>
        <Row>
          <div className="text-center">{message}</div>
        </Row>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          onClick={onToggle}
          className="btn btn-secondary"
          data-dismiss="modal"
        >
          {t("Đóng")}
        </button>
        <button
          type="button"
          onClick={onSubmit}
          className="btn btn-info save-user"
        >
          {t("Xác nhận")}
        </button>
      </ModalFooter>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  onDelete: PropTypes.func,
  onToggle: PropTypes.func,
  modal: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  t: PropTypes.any,
}
ConfirmModal.defaultProps = {
  onDelete: () => { },
  onToggle: () => { },
  onSubmit: () => { },
  title: "title",
  message: "message",
}

export default withTranslation(["common"])(ConfirmModal)
